// extracted by mini-css-extract-plugin
module.exports = {"sNftAttributes":"sNftAttributes_sNftAttributes__yR59y","sProperty":"sNftAttributes_sProperty__iKv4q"};